module.exports = __webpack_public_path__ + "img/IMG_9702.31152fe1.jpg";